const delay = 5000;
export default {
    directives: {
        'preventClick': {
            inserted(el, bind) {
                if (bind.value) {
                    el.addEventListener('click', () => {
                        if (!el.disabled) {
                            el.disabled = true;
                            el.className += ' is-disabled';
                            setTimeout(() => {
                                el.disabled = false;
                                el.className = el.className.replace(/is-disabled/, '').trim();
                            }, delay);
                        }
                    });
                }
            }
        }
    }
};
